module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "uk-button uk-button-default",
    attrs: {
      "href": ("#image-modal-" + _vm.componentID),
      "uk-toggle": ""
    }
  }, [_vm._v(_vm._s(_vm.multiple ? "Kies foto's" : "Kies foto"))]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-container",
    attrs: {
      "id": ("image-modal-" + _vm.componentID),
      "uk-modal": ""
    }
  }, [_c('div', {
    staticClass: "uk-modal-dialog"
  }, [_c('button', {
    staticClass: "uk-modal-close-default",
    attrs: {
      "type": "button",
      "uk-close": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-header"
  }, [_c('h2', {
    staticClass: "uk-modal-title uk-align-left"
  }, [_vm._v(_vm._s(_vm.multiple ? "Kies foto's" : "Kies foto"))]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.choose($event)
      }
    }
  }, [_vm._v("Kies")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-body",
    attrs: {
      "uk-overflow-auto": ""
    }
  }, [_c('div', {
    staticClass: "uk-child-width-1-6@m",
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.media), function(m, id) {
    return _c('div', [_c('div', {
      staticClass: "uk-card uk-link uk-card-default"
    }, [_c('div', {
      staticClass: "uk-card-media-top"
    }, [_c('img', {
      attrs: {
        "src": m.url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.select(id, m)
        }
      }
    })]), _vm._v(" "), (_vm.selected[id]) ? _c('div', {
      staticClass: "uk-card-badge uk-label"
    }, [_c('span', {
      attrs: {
        "uk-icon": "check"
      }
    })]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "uk-modal-footer"
  }, [_c('button', {
    staticClass: "uk-button uk-button-primary uk-align-right uk-modal-close",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.choose($event)
      }
    }
  }, [_vm._v("Kies")]), _vm._v(" "), _c('button', {
    staticClass: "uk-button uk-button-danger uk-align-right uk-modal-close"
  }, [_vm._v("Annuleren")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12a5200a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/MEDIA/imagePicker.vue
// module id = 506
// module chunks = 1